import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=4dd905cf&scoped=true&"
import script from "./AddEvent.vue?vue&type=script&lang=js&"
export * from "./AddEvent.vue?vue&type=script&lang=js&"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=4dd905cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd905cf",
  null
  
)

export default component.exports